import React, { useEffect } from 'react';
import { DISCORD_CALLBACK_URL } from '../api';

const Callback = () => {
  useEffect(() => {
    const handleCallback = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        if (!code) {
          throw new Error('No code found in URL');
        }

        window.location.href = `${DISCORD_CALLBACK_URL}?code=${code}`;
      } catch (error) {
        console.error('Error handling Discord OAuth callback:', error);
      }
    };

    handleCallback();
  }, []);

  return (
    <div>Loading...</div>
  );
};

export default Callback;